module.exports = __webpack_public_path__ + "static/media/Logo__Bloomberg.612e9568.svg";